import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { createSelector } from 'reselect';

import { currentUserSelector } from '../reducers/users';

import OrganizationCard from '../components/cards/OrganizationCard';
import { OrganizationActions } from '../actions/organization';

import '../styles/ProjectCardsContainer.css';

class OrganizationCards extends PureComponent {
  static propTypes = {
    organizations: PropTypes.instanceOf(Map).isRequired,
    users: PropTypes.instanceOf(Map).isRequired,
    currentUser: PropTypes.instanceOf(Map),
  };

  organizations() {
    const { organizations, currentUser, dispatch } = this.props;

    const organizationsArray = [];
    const sortedOrganizations = [];

    if (!organizations || !organizations.size) {
      return null;
    }

    organizations.forEach(a => {
      sortedOrganizations.push(a);
    });

    sortedOrganizations.sort(
      (a, b) => new Date(b.get('created_at')) - new Date(a.get('created_at')),
    );

    sortedOrganizations.forEach((v, k) => {
      // debugger;
      // const { users } = this.props;
      // const user = users.get(v.get('user')) ? users.get(v.get('user')) : null;
      // console.log('USR', user, users);
      organizationsArray.push(
        <OrganizationCard
          organization={v}
          dispatch={dispatch}
          key={k}
          currentUser={currentUser}
        />,
      );
    });

    return organizationsArray;
  }

  render() {
    const organizationsList = this.organizations();
    return <div className="row col-xs projects-list">{organizationsList}</div>;
  }
}

function selectOrganizations(organizations) {
  return organizations;
  // return organizations.filter((project, key) => {
  //   return project.get('id') > 607 || project.get('id') === 479;
  // });
}

const organizationsSelector = state => {
  return state.organizations.get('organizations');
};
const usersSelector = state => state.users.get('users');

const ProjectCardsSelector = createSelector(
  [organizationsSelector, currentUserSelector, usersSelector],
  (organizations, currentUser, users) => {
    return {
      organizations: selectOrganizations(organizations),
      currentUser,
      users,
    };
  },
);

@connect(ProjectCardsSelector)
export default class OrganizationCardsContainer extends PureComponent {
  static propTypes = {
    organizations: PropTypes.instanceOf(Map),
    users: PropTypes.instanceOf(Map),
    currentUser: PropTypes.instanceOf(Map),
    dispatch: PropTypes.func,
  };

  componentWillMount() {
    const { dispatch } = this.props;
    dispatch(
      OrganizationActions.getOrganizations({
        fields: ['users', 'elements', 'elementTypes', 'creator'],
      }),
    );
  }

  render() {
    const { organizations } = this.props;
    if (!organizations) {
      return null;
    }
    return <OrganizationCards {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/OrganizationCardsContainer.js